import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import useLangTranslation from "../../../customHooks/languageProvider";

const DeleteSelectedScreenshot = ({
  showModal,
  closeModal,
  selectedScreenshots,
  handleDelete,
  isDeleteAllSelected = 0
}) => {
  const [isRadioChecked, setIsRadioChecked] = useState(0);
  const { getLangTranslation } = useLangTranslation();

  const handleClick = (checked) => {
    setIsRadioChecked(checked);
  };

  return (
    <Modal show={showModal} size="sm" className="custom-modal blur-bg" centered>
      <Modal.Header>
        <div className="border-0 pb-0 d-flex justify-content-between w-100">
          <h6 className="modal-title text-blue-900">
            {getLangTranslation(
              "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
              "Delete selected"
            )}
          </h6>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body className="py-3 px-4">
        <>
          <div
            className={`p-3 d-flex align-items-center mb-3 pt-cursor justify-content-between border rounded-3 ${
              isRadioChecked === 1 ? "bg-gray-300" : "border-white"
            }`}
            onClick={() => {
              handleClick(1);
            }}
          >
            <h6 className="mb-0 text-blue-900">
              {getLangTranslation(
                "WEB_ACTIVITY_DELETE_FROM_ACTIVITY_ONLY",
                "Delete from activity only"
              )}
            </h6>
            <input
              className="form-check-input"
              type="radio"
              name="createTask"
              checked={isRadioChecked === 1}
              onChange={() => {}}
            />
          </div>
         
          <button
            className="btn btn-primary w-100"
            type="button"
            disabled={
              isRadioChecked
                ? isDeleteAllSelected
                  ? false
                  : selectedScreenshots.length < 1
                  ? true
                  : false
                : true
            }
            onClick={() => handleDelete(isRadioChecked)}
          >
            <span
              className="btn-upper-case"
            >
              {getLangTranslation("DELETE_CHILD_DELETE", "Delete")}
            </span>
          </button>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteSelectedScreenshot;
